import { Navigate } from 'react-router-dom';
import { clearAccessToken, isTokenValid } from '@/utils/token';

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  if (!isTokenValid()) {
    clearAccessToken();
    return <Navigate to="/auth" replace />;
  }

  return <>{children}</>;
};
